import React from 'react';
import WorkingArea from 'components/WorkingAreas/WorkingAreas';
import InsourceLayout from 'components/Layout/DataEntryLayout/Layout';
import OutsourceLayout from 'components/Layout/ReportingLayout/Layout';
import LoginForm from 'pages/Login/Login';
import ForgotPass from 'pages/ForgotPassword/ForgotPassword';
import ChangePassword from 'pages/ChangePassword/ChangePassword';
import SignUp from 'pages/Signup/Signup';
import AdditionalReportingLayout from 'components/Layout/AdditionalReporting/Layout';
import ResetPass from 'pages/ResetPassword/ResetPassword';
import Report99Steps from 'pages/Report99/Report99';
import DataManagementLayout from 'components/Layout/DataManagementLayout/Layout';
import SuperAdmin from 'pages/SuperAdmin/SuperAdmin';
import UserAccessRightsLayout from 'components/Layout/UserAccessRights/Layout';
import MainInventories from 'components/Layout/Article8/MainInventories';
import ICTRiskSteps from 'pages/Steps/ICTRiskSteps';
import AllocationLayout from 'components/Layout/AllocationLayout/Layout';
import Article8ReportingLayout from 'components/Layout/Article8Reports/Layout';
import RiskExposure from 'components/Tables/DataManagement/Article8/RiskExposure';
import DependencyType from 'components/Tables/DataManagement/Article8/DependencyType';
import ExposureCategory from 'components/Tables/DataManagement/Article8/ExposureCategory';
import EntityRole from 'components/Tables/DataManagement/Article8/EntityRole';
import RoleType from 'components/Tables/DataManagement/Article8/RoleType';
import ICTRiskLevel from 'components/Tables/DataManagement/Article8/ICTRiskLevel';
import Responsibility from 'components/Tables/DataManagement/Article8/Responsibility';
import ICTSystemCriticality from 'components/Tables/DataManagement/Article8/ICTSystemCriticality';
import ICTRiskSource from 'components/Tables/DataManagement/Article8/ICTRiskSource';
import RoleTypeSteps from 'pages/Steps/RoleTypeSteps';
import ICTRiskExposureSteps from 'pages/Steps/ICTRiskExposureSteps';
import RegisterOfInformationSteps from 'pages/Steps/RegisterOfInformationSteps';
import RiskExposureTree from 'components/Tables/Reporting/RiskDashboard/RiskToTPP/RiskExposureTree';
import DashboardLayout from 'components/Layout/DashboardLayout/Dashboard';
import EntityToFunctionTree from 'components/Tables/Reporting/RiskDashboard/EntityToFunction/EntityToFunction';
import EntityToTPPTree from 'components/Tables/Reporting/RiskDashboard/EntityToTPP/EntityToTPP';
import EntityToFunctionReverseTree from 'components/Tables/Reporting/RiskDashboard/EntityToFunctionReverse/EntityToFunctionReverse';

const routes = [
  {
    id: 1,
    path: '/',
    private: false,
    component: () => <LoginForm />,
  },
  {
    id: 2,
    path: '/working_area',
    private: false,
    component: () => <WorkingArea />,
  },
  {
    id: 3,
    path: '/data_entry',
    private: true,
    component: () => <InsourceLayout />,
  },
  {
    id: 4,
    path: '/reporting',
    private: true,
    component: () => <OutsourceLayout />,
  },
  {
    id: 5,
    path: '/data_entry/entity',
    private: true,
    component: () => <RegisterOfInformationSteps />,
  },
  {
    id: 6,
    path: '/data_entry/third_party_provider',
    private: true,
    component: () => <RegisterOfInformationSteps />,
  },
  {
    id: 7,
    path: '/data_entry/branch',
    private: true,
    component: () => <RegisterOfInformationSteps />,
  },
  {
    id: 8,
    path: '/data_entry/function',
    private: true,
    component: () => <RegisterOfInformationSteps />,
  },
  {
    id: 9,
    path: '/forgot_password',
    private: false,
    component: () => <ForgotPass />,
  },
  {
    id: 10,
    path: '/data_entry/ict_service',
    private: true,
    component: () => <RegisterOfInformationSteps />,
  },
  {
    id: 11,
    path: '/data_entry/contractual_information',
    private: true,
    component: () => <RegisterOfInformationSteps />,
  },
  {
    id: 12,
    path: '/change_pass',
    private: true,
    component: () => <ChangePassword />,
  },
  {
    id: 13,
    path: '/sign_up',
    private: false,
    component: () => <SignUp />,
  },
  {
    id: 14,
    path: '/additional_reporting',
    private: true,
    component: () => <AdditionalReportingLayout />,
  },
  {
    id: 15,
    path: '/reset_password',
    private: false,
    component: () => <ResetPass />,
  },
  {
    id: 16,
    path: '/data_entry/entity_maintaining_registry',
    private: true,
    component: () => <RegisterOfInformationSteps />,
  },
  {
    id: 17,
    path: '/data_management/data',
    private: true,
    component: () => <RegisterOfInformationSteps />,
  },
  {
    id: 18,
    path: '/data_management/report99',
    private: true,
    component: () => <Report99Steps />,
  },
  {
    id: 19,
    path: '/data_management',
    private: true,
    component: () => <DataManagementLayout />,
  },
  {
    id: 20,
    path: '/data_management/ict_systems',
    private: true,
    component: () => <RegisterOfInformationSteps />,
  },
  {
    id: 21,
    path: '/super_admin',
    private: false,
    component: () => <SuperAdmin />,
  },
  {
    id: 22,
    path: '/user_access_rights',
    private: true,
    component: () => <UserAccessRightsLayout />,
  },
  {
    id: 23,
    path: '/article8',
    private: true,
    component: () => <MainInventories />,
  },
  {
    id: 24,
    path: '/article8/risk_exposure',
    private: true,
    component: () => <RiskExposure />,
  },
  {
    id: 25,
    path: '/article8/dependency_type',
    private: true,
    component: () => <DependencyType />,
  },
  {
    id: 26,
    path: '/article8/exposure_category',
    private: true,
    component: () => <ExposureCategory />,
  },
  {
    id: 27,
    path: '/article8/ict_system_criticality',
    private: true,
    component: () => <ICTSystemCriticality />,
  },
  {
    id: 28,
    path: '/article8/entity_role',
    private: true,
    component: () => <EntityRole />,
  },
  {
    id: 29,
    path: '/article8/role_type',
    private: true,
    component: () => <RoleType />,
  },
  {
    id: 30,
    path: '/article8/ict_risk',
    private: true,
    component: () => <ICTRiskSteps />,
  },
  {
    id: 31,
    path: '/article8/risk_source',
    private: true,
    component: () => <ICTRiskSource />,
  },
  {
    id: 32,
    path: '/article8/risk_level',
    private: true,
    component: () => <ICTRiskLevel />,
  },
  {
    id: 33,
    path: '/article8/responsibility',
    private: true,
    component: () => <Responsibility />,
  },
  {
    id: 34,
    path: '/allocation',
    private: true,
    component: () => <AllocationLayout />,
  },
  {
    id: 35,
    path: '/article_8_reporting',
    private: true,
    component: () => <Article8ReportingLayout />,
  },
  {
    id: 36,
    path: '/article8/risk_exposure_layout',
    private: true,
    component: () => <ICTRiskExposureSteps />,
  },
  {
    id: 37,
    path: '/article8/master_data',
    private: true,
    component: () => <RoleTypeSteps />,
  },
  {
    id: 38,
    path: '/dashboard/ict-risk-to-tpp',
    private: true,
    component: () => <RiskExposureTree />,
  },
  {
    id: 39,
    path: '/dashboard',
    private: true,
    component: () => <DashboardLayout />,
  },
  {
    id: 40,
    path: '/dashboard/entity-to-function',
    private: true,
    component: () => <EntityToFunctionTree />,
  },
  {
    id: 41,
    path: '/dashboard/entity-to-tpp',
    private: true,
    component: () => <EntityToTPPTree />,
  },
  {
    id: 42,
    path: '/dashboard/entity-to-function-reverse',
    private: true,
    component: () => <EntityToFunctionReverseTree />,
  },
];

export default routes;
